import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import TextFiledWithLabel from '../../Components/TextFieldWithLabel'
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable'
import { AddMoreButton, RemoveAddedFieldButton } from '../../Components/AddMoreOrRemoveButton'
import { getEntityColumns } from '../../Utility/apiHelper'
import { handleValidateCodevalue, STATIC_ENTITY_CONFIG } from '../../Utility/constant'
import LeadDialog from '../../Components/LeadDialog'
import './workflow.css';

const emptyMapping = { sourceField: "", targetField: "" };

const FieldMappingDialog = ({ open, isViewMode, defaultValues, handleCloseDialog, onSave }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)

    const [rows, setRows] = useState(defaultValues?.length ? defaultValues : [emptyMapping]);

    useEffect(() => {
        setRows(defaultValues?.length ? defaultValues : [emptyMapping]);
    }, [defaultValues, open]);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const targetFields = React.useMemo(() => {
        const data = getEntityColumns(allEntityData, "LEAD");
        const { id, customerId, status, ...rest } = Object.keys(data).length > 0 ? data : (STATIC_ENTITY_CONFIG?.LEAD || {});
        const baseOptions = Object.entries(rest)
            .map(([fieldKey, fieldVal]) => {
                const configLabel = STATIC_ENTITY_CONFIG?.LEAD?.[fieldKey]?.label || fieldKey;
                return {
                    label: handleValidateCodevalue(internationalise, configLabel),
                    value: fieldKey
                };
            });
        
        baseOptions.push({
            label: "Follow Up Note",
            value: "followupNote"
        });

        return baseOptions;
    }, [allEntityData, internationalise]);

    const handleRowChange = (index, event) => {
        const { name, value } = event?.target || {};
        if (!name) return;
        setRows(prev => {

            const newRows = [...prev];
            newRows[index] = { ...newRows[index], [name]: value };
            return newRows;
        });
    };

    const saveMappings = () => {
        const validRows = rows.filter(row => row?.targetField && row?.sourceField);
        onSave(validRows);
    };

    return (
        <LeadDialog
            open={open}
            handleClose={handleCloseDialog}
            title={handleValidateCodevalue(internationalise, "WF_TP_MAPPING_TITLE")}
            size="sm"
            btnlabel={handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
            handleSave={!isViewMode ? saveMappings : undefined}
            paperProps={{ className: "workflow-field-mapping-dialog" }}
        >
            <Box className="workflow-field-mapping-content">
                {rows.map((row, index) => (
                    <Box
                        key={`field-mapping-${index}`}
                        className="workflow-field-mapping-row"
                    >
                        <Typography className="workflow-mapping-number">
                            {index + 1}.
                        </Typography>
                        <TextFiledWithLabel
                            name="sourceField"
                            disabled={isViewMode}
                            value={row.sourceField || ''}
                            label={handleValidateCodevalue(internationalise, "WF_MAPPING_SOURCE_FIELD")}
                            handleOnChange={(e) => handleRowChange(index, e)}
                        />

                        <span className="info-text workflow-mapping-label">
                            is mapped to
                        </span>

                        <SelectBoxWithLabel
                            select
                            name="targetField"
                            disabled={isViewMode}
                            value={row.targetField || ''}
                            label={handleValidateCodevalue(internationalise, "WF_MAPPING_TARGET_FIELD")}
                            optionMenuItem={targetFields}
                            handleOnChange={(e) => handleRowChange(index, e)}
                        />
                        <RemoveAddedFieldButton
                            setRows={setRows}
                            index={index}
                            visible={rows.length > 1 && !isViewMode}
                        />
                    </Box>
                ))}
                <AddMoreButton
                    visible={!isViewMode}
                    setRows={setRows}
                    addParams={emptyMapping}
                />
            </Box>
        </LeadDialog>
    )
}

export default FieldMappingDialog
